import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { useExternalIntegrations } from 'components/ExportModal/ExternalIntegrations/ExternalIntegrations'
import { useFlipperFlag } from './useFlipperFlag'
import {
  hasBlogIntegrationConnected,
  canConnectBlogProvider,
  getConnectedBlogIntegration,
  getBlogIntegrationRestrictionMessage,
} from 'utils/blogIntegrationRestrictions'
import { BlogPlatformIntegration } from 'types'

export const useBlogIntegrations = () => {
  const { data } = useExternalIntegrations()
  const goHighLevelEnabled = useFlipperFlag('go_high_level_integration')
  const wixEnabled = useFlipperFlag('wix_blog_integration')
  const shopifyEnabled = useFlipperFlag('shopify_integration')
  const integrations = data?.external_integrations

  if (!integrations) {
    return {
      blogIntegrations: [],
      hasBlogIntegrationConnected: false,
      canConnectWordPress: true,
      canConnectGoHighLevel: goHighLevelEnabled,
      canConnectWix: wixEnabled,
      canConnectShopify: shopifyEnabled,
      connectedBlogIntegration: null,
      getRestrictionMessage: () => null,
    }
  }

  const supportedProviders = [ExternalIntegrationEnum.WordPress]

  if (goHighLevelEnabled) {
    supportedProviders.push(ExternalIntegrationEnum.GoHighLevel)
  }

  if (wixEnabled) {
    supportedProviders.push(ExternalIntegrationEnum.Wix)
  }

  if (shopifyEnabled) {
    supportedProviders.push(ExternalIntegrationEnum.Shopify)
  }

  const blogIntegrations = integrations.filter((integration) => supportedProviders.includes(integration.provider))

  const hasBlogConnected = hasBlogIntegrationConnected(integrations)
  const connectedBlogIntegration = getConnectedBlogIntegration(integrations)
  const canConnectWordPress = canConnectBlogProvider(integrations, ExternalIntegrationEnum.WordPress)
  const canConnectGoHighLevel =
    goHighLevelEnabled && canConnectBlogProvider(integrations, ExternalIntegrationEnum.GoHighLevel)
  const canConnectWix = wixEnabled && canConnectBlogProvider(integrations, ExternalIntegrationEnum.Wix)
  const canConnectShopify = shopifyEnabled && canConnectBlogProvider(integrations, ExternalIntegrationEnum.Shopify)

  const getRestrictionMessage = (provider: BlogPlatformIntegration) => {
    return getBlogIntegrationRestrictionMessage(integrations, provider)
  }

  return {
    blogIntegrations,
    hasBlogIntegrationConnected: hasBlogConnected,
    canConnectWordPress,
    canConnectGoHighLevel,
    canConnectWix,
    canConnectShopify,
    connectedBlogIntegration,
    getRestrictionMessage,
  }
}
